import React from 'react'
import { FcApproval } from 'react-icons/fc'
import { BsFacebook, BsYoutube, BsInstagram } from 'react-icons/bs'
import './ContactModal.css'
import { useNavigate } from 'react-router-dom'
const ContactModal = () => {
const navigate = useNavigate()
const sendToGallery = () => {
    navigate('/gallery', { replace: true })
}
return (
    <div className="contact-modal-container">
    <FcApproval className="contact-success-icon" />
    <div className="contact-gallery-div">
        <h1>Thank You!</h1>
        <h3>
        Your request was submitted successfully. We will be in contact with
        you shortly.
        </h3>
        <h4>
        Be sure to check out our gallery for ideas on your next project!
        </h4>
        <button className="contact-modal-btn" onClick={sendToGallery}>
        Gallery
        </button>
        <h4>Follow Us:</h4>
    </div>
    <div className="contact-icon-container">
        <a href="https://www.facebook.com/TangledLeadWelding" target="_blank">
        <BsFacebook className="contact-icon" />
        </a>
        <BsYoutube className="contact-icon" />
        <BsInstagram className="contact-icon" />
    </div>
    </div>
)
}

export default ContactModal

